import IconContainer from "@/components/ui/icon-container";
import { DetailedViewOptions } from "@/components/controls/OptionsDropdownMenu/OptionsDropdownMenu";
import { Edit, Regenerate } from "@dreamhub/designsystem/icons";

type MenuOption = DetailedViewOptions[string];

export const renameOption = (
  action: () => void,
  disabled: boolean
): MenuOption => ({
  action,
  disabled,
  customIcon: (
    <IconContainer size="5" color="secondary">
      <Edit />
    </IconContainer>
  )
});

export const regenerateOption = (
  action: () => void,
  disabled: boolean,
  blockedReason?: string
): MenuOption => ({
  action,
  disabled: disabled || !!blockedReason,
  disabledTooltipText: blockedReason,
  customIcon: (
    <IconContainer size="5" color="secondary">
      <Regenerate />
    </IconContainer>
  )
});

export const reviseOption = (
  action: () => void,
  disabled: boolean
): MenuOption => ({
  action,
  disabled,
  customIcon: (
    <IconContainer size="5" color="secondary">
      <Edit />
    </IconContainer>
  )
});

// Destructive, as Delete is: the customer's signing link stops working. Its icon
// comes from the menu's own map, so it is tinted as the item is.
export const withdrawOption = (
  action: () => void,
  disabled: boolean
): MenuOption => ({
  action,
  disabled,
  variant: "destructive"
});
